import { render, staticRenderFns } from "./MDS.vue?vue&type=template&id=5be8ca15&scoped=true"
import script from "./MDS.vue?vue&type=script&lang=js"
export * from "./MDS.vue?vue&type=script&lang=js"
import style0 from "./MDS.vue?vue&type=style&index=0&id=5be8ca15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be8ca15",
  null
  
)

export default component.exports